// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"472":"dcb67a9a","694":"28eff522","747":"cf211538","864":"bb7aad19","987":"4cbc9c25","989":"e46f3a90"}[chunkId] + ".chunk.js";
};